import 'core-js/stable/global-this';
import React, { useEffect, useState } from "react";
// Resize
import useWindowSize from "Hooks/useWindowSize";

//Libraries
import Slider from "react-slick";

// Sass
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ce20.css";

import Parser from "html-react-parser";
import FormularioHogar from './formularioHogar';

function ActivarComponent(props) {
    const { idBanco, banks, config, Terms5, deparments, entities, modalities, operators, documentType, planes } = props;

  const [showCE41Form, setShowCE41Form] = useState("davivienda");

  const [showBanco, setShowBanco] = useState(true);

  const [dataDepartments, setDataDepartments] = useState([]);
  const [dataEntities, setDataEntities] = useState([]);
  const [dataModalities, setDataModalities] = useState([]);
  const [dataOperators, setDataOperators] = useState([]);
  const [dataDocumentTypes, setDataDocumentTypes] = useState([]);
  const [dataPlanes, setDataPlanes] = useState([]);
  // const [dataPlanByID, setDataPlanByID] = useState([])
  // const [dataOfBanks, setDataOfBanks] = useState(banks);
  const [dataConfig] = useState(config);
  const [txtTerms5, setTxtTerms5] = useState('');

  console.log(banks, dataDocumentTypes, "banks")

  const getValuesDefault = async () => {

    console.log("banks: ", banks);
    console.log("config: ", config);
   
    if(config?.text_TERMS_5 && String(config?.text_TERMS_5).indexOf("http") >= 0){
      console.log("Terms5: ", Terms5);
      setTxtTerms5(Terms5);
    }
    
    if(banks.length > 0){
      if (banks?.length && config?.title_REGISTRE) {
        let deparmentsFilt = deparments
          ? deparments.filter((dp) => dp.fi_banco === idBanco)
          : [];
          
        setDataDepartments(deparmentsFilt);
  
        let entitiesFilt = entities
          ? entities.filter((ent) => ent.fi_banco === idBanco)
          : [];
        setDataEntities(entitiesFilt);
  
        let modalitiesFilt = modalities
          ? modalities.filter((mo) => mo.fi_banco === idBanco)
          : [];
        setDataModalities(modalitiesFilt);
  
        let operatorsFilt = operators
          ? operators.filter((op) => op.fi_banco === idBanco)
          : [];
        setDataOperators(operatorsFilt);
  
        let documentTypeFilt = documentType
          ? documentType.filter((dt) => dt.fi_banco === idBanco)
          : [];
        console.log(documentTypeFilt, "banks2")
        setDataDocumentTypes(documentTypeFilt);
  
        let planesFilter = planes
          ? planes.filter((pl) => pl.fi_banco === idBanco)
          : [];
        setDataPlanes(planesFilter);
  
        console.log("planes....> ", planesFilter);
        console.log("documentType....> ", documentTypeFilt);
        console.log("deparments....> ", deparmentsFilt);
        console.log("entities....> ", entitiesFilt);
        console.log("operators....>", operatorsFilt);
        console.log("modalities: ", modalitiesFilt);
      }

    } else {
        setShowBanco(false);
    }
    
    
    
  };

  useEffect(() => {
    getValuesDefault();
    // eslint-disable-next-line
  }, []);

  const ajustarCard = function (className) {
    var altura, i, maxHeight, total;
    var els = document.getElementsByClassName(className);

    // Limpia todos los height
    Array.prototype.forEach.call(els, function (el) {
      el.style.height = "";
    });

    // Se optienen todos los height
    altura = [];
    total = els.length - 1;
    i = 0;
    while (i <= total) {
      altura.push(els[i].offsetHeight);
      i++;
    }
    // Se optiene la height maxima entre todas las tarjetas
    maxHeight = Math.max.apply(null, altura);

    // Se aplica a todos la height
    Array.prototype.forEach.call(els, function (el) {
      // console.log(el.offsetHeight);
      el.style.height = maxHeight + "px";
    });
  };

  const {
    // height: heightWindow,
    width: widthWindow,
  } = useWindowSize();

  // ajusta siempre que cambia
  useEffect(() => {
    ajustarCard("ce20ItemHeader");
    ajustarCard("ce20ItemDesc");
  }, []);

  useEffect(() => {
    ajustarCard("ce20ItemHeader");
    ajustarCard("ce20ItemDesc");
  }, [widthWindow]);

  const settingsSlider = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: false,
    centerMode: true,
    centerPadding: "28px",
    responsive: [
      {
        breakpoint: 640,
      },
      {
        breakpoint: 100000,
        settings: "unslick",
      },
    ],
  };


  return (
    <>
       {showCE41Form === "davivienda" && (
        <>
          { true ? (
            <section className="ce20Wrap light">
              <div className="container">
                <div className="ce20">
                  <div className="ce20Title">
                    <h2>{dataConfig.title_REGISTRE}</h2>
                    <p>{dataConfig.desc_REGISTRE}</p>
                  </div>
                  <Slider
                    {...settingsSlider}
                    className={``}
                  >
                    {dataConfig.t_CARD_1_HOGAR ? (<div className="ce20Item">
                      <div className="cardSupport" >
                        <i className={dataConfig.ico_BOX_1_HOGAR}></i>
                        <h3 className="h4 ce20ItemHeader">
                          {Parser(dataConfig.t_CARD_1_HOGAR)}
                        </h3>
                        {dataConfig?.d_CARD_1_HOGAR && <p className="ce20ItemDesc">{Parser(dataConfig.d_CARD_1_HOGAR)}</p>}
                      </div>
                    </div>):""}
                    {dataConfig.t_CARD_2_HOGAR ? (<div className="ce20Item">
                      <div className="cardSupport">
                        <i className={dataConfig.ico_BOX_2_HOGAR}></i>
                        <h3 className="h4 ce20ItemHeader">
                          {Parser(dataConfig.t_CARD_2_HOGAR)}
                        </h3>
                        {dataConfig?.d_CARD_2_HOGAR && <p className="ce20ItemDesc">{Parser(dataConfig.d_CARD_2_HOGAR)}</p>}
                      </div>
                    </div>):""}
                    {dataConfig.t_CARD_3_HOGAR ? (<div className="ce20Item">
                      <div className="cardSupport" >
                        <i className={dataConfig.ico_BOX_3_HOGAR}></i>
                        <h3 className="h4 ce20ItemHeader">
                          {Parser(dataConfig.t_CARD_3_HOGAR)}
                        </h3>
                        {dataConfig?.d_CARD_3_HOGAR && <p className="ce20ItemDesc">{Parser(dataConfig.d_CARD_3_HOGAR)}</p>}
                      </div>
                    </div>):""}
                  </Slider>
                  <div className="ce20Extra">
                      {dataConfig?.text_EXTRA && <p>{Parser(String(  (dataConfig.text_EXTRA==null)?"":dataConfig.text_EXTRA ))}</p>}
                      <button
                        className="btn btnPrimario"
                        onClick={(e) => {
                          console.log("hola")
                          setShowCE41Form("formularioHogar")
                        }}
                      >
                        Activar
                      </button>
                      
                    </div>
                  <div className="ce20Copys">
                    <ul className="dottedList">
                      {Parser(String( (dataConfig.text_LIST==null)?"": dataConfig.text_LIST)  )}
                    </ul>
                    <p>{Parser(String( (dataConfig.text_DUDAS_CORREO==null)?"":dataConfig.text_DUDAS_CORREO ) )}</p>
                  </div>
                </div>
              </div>
            </section>
          ) : !showBanco ? 
            <section className="ce20Wrap light">
              <div className="container">
                <div className="ce20">
                  <div className="ce20Title">
                    <h2>Banco no disponible</h2>
                  </div>
                </div>
              </div>
            </section>            
          :null}
        </>
      )}

      { dataDocumentTypes.length && showCE41Form === "formularioHogar" && (
        <FormularioHogar
          dataConfig={dataConfig}
          txtTerms5={txtTerms5}
          dataOfBanks={banks}
          idBanco={idBanco}
          dataPlanes={dataPlanes}
          dataDocumentTypes={dataDocumentTypes}
          dataDepartments={dataDepartments}
          dataEntities={dataEntities}
          dataOperators={dataOperators}
          dataModalities={dataModalities}
        />
      )}
    </>
  );
}

ActivarComponent.defaultProps = {
  refHead: [],
  itemsHeadRef: [],
};

export default ActivarComponent;
